<template>
    <div class="lechun-alert-box" v-show="couponBoxShow">
        <template v-for="(item,index) in indexBannerList" v-if="index<=0">
            <div class="alert_group">
                <img class="top" @click="toUrl(item.url)" :src="item.picurl">
                <i class="x icon iconfont icon-close" @click="closeBox"></i>
            </div>
        </template>

    </div>
</template>
<script>
    import {isUserLogin} from '@/resource/js/GLOBAL2'
    import {setCookie, getCookie} from '@/resource/js/common'

    export default {
        data() {
            return {
                couponBoxShow: false,
            }
        },
        computed:{
            indexBannerList:function () {
                let boxList = this.$store.state.indexBanner.indexBox;
                this.initBox(boxList)
                return boxList
            }
        },
        methods: {
            initBox(list){
                if (getCookie("alertBanner") != 2 && isUserLogin() == 1 &&list.length>0){
                    this.couponBoxShow = true;
                    setCookie("alertBanner", 2, true);
                } else {
                    this.couponBoxShow = false;
                }
            },
            toUrl(url) {

                window.location.href = url;
            },
            closeBox() {
                this.couponBoxShow = false;
            },
        }
    }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .lechun-alert-box {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
        .alert_group {
            position: absolute;
            top: 44%;
            left: 50%;
            width: 100%;
            -webkit-transform: translate(-50%, -50%);
        }
        .top {
            width: 5.6rem;
            height: auto;
            max-height: 7rem;
            display: block;
            position: relative;
            margin: 0 auto;
        }
        .x {
            width: 100%;
            height: auto;
            display: block;
            position: absolute;
            top: 7.2rem;
            font-size: .8rem;
            color:#ffffff;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/indexBanner/indexBanner.vue